// extracted by css-extract-rspack-plugin
export default {"selectable":"ConflictingFilesList-module__selectable__Clwyk","uninteractive":"ConflictingFilesList-module__uninteractive__QClM_"};